/* tslint:disable */
/* eslint-disable */
export enum PersonAddressType {
  HOME = 'HOME',
  MAILING = 'MAILING'
}
